import { Config } from 'app/config.const';
import { IAppuntamento } from 'app/model/appuntamento';
import { CFID, IID } from 'app/model/id';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { filter, map, merge, share, tap } from 'rxjs/operators';
import { isNumber, isObject } from 'util';
import { WebSocketObservable, WebSocketReadyState } from '../angular-rest';
import { IConflict, IDeleteGroupRequest, IDeleteRequest, IIDPostback } from './appuntamenti';
import { prepareDataForAuth } from '../../utils';

export class WebSocketError extends Error {
	constructor(public readonly errno: number) {
		super();
	}
}

export interface IVersioned {
	version: number;
}

export interface IConflict<T extends IVersioned> {
	value: T;
	most_recent: T;
}

export interface IIDPostback extends IID<string> {
	request_id: string;
}

export interface IDeleteRequest<T> {
	delete: T;
}

export interface IDeleteGroupRequest<T> {
	delete_group: T;
}

/**
 * Questa calsse non ha senso di essere un observable/di implementare
 * le interfaccie come oggetti osservabili perché il suo stream va in
 * qualsiasi caso mappato manualmente in jQuery (Full Calendar)
 * 
 * @export
 * @class Appuntamenti
 */
export class Appuntamenti {
	public readonly postback: Observable<IIDPostback>;
	public readonly updates: Observable<IAppuntamento>;
	public readonly conflicts: Observable<IConflict<IAppuntamento>>;
	public readonly deletes: Observable<IDeleteRequest<number>>;
	public readonly status: Observable<WebSocketReadyState>;

	private readonly ws: Observable<IConflict<IAppuntamento>|IIDPostback|IAppuntamento|IDeleteRequest<number>>;
	private readonly updater: Subject<IAppuntamento|IDeleteRequest<number>|IDeleteGroupRequest<number>>;

	constructor(agenda: CFID, from: moment.Moment, to: moment.Moment) {

		this.updater = new Subject<IAppuntamento|IDeleteRequest<number>>();
		
		const __data = prepareDataForAuth('Appuntamenti.constructor()')

		const ws = new WebSocketObservable<
				IConflict<IAppuntamento>|IIDPostback|IAppuntamento|IDeleteRequest<number>|number, 
				IAppuntamento|IDeleteRequest<number>|IDeleteGroupRequest<number>
			>(
				this.updater.asObservable(),
				`${Config.webSocketURI}/agende/${agenda.codice_fiscale}/${agenda.nome}/` +
				`${from.format('YYYY-MM-DD')}/${to.format('YYYY-MM-DD')}/eventi?__data=${__data}`
			);

		this.status = ws.status.pipe(share());

		const shared_ws = ws.pipe(
			share()
		) as Observable<IConflict<IAppuntamento>|IIDPostback|IAppuntamento|IDeleteRequest<number>>;

		const start = moment.utc();

		this.conflicts = shared_ws.pipe(
				filter((c) => isObject(c) && 'most_recent' in c)
			) as Observable<IConflict<IAppuntamento>>;

		this.postback = shared_ws.pipe(
				filter(c => isObject(c) && 'request_id' in c)
			) as Observable<IIDPostback>;
		
		this.deletes = shared_ws.pipe(
				filter(c => isObject(c) && 'delete' in c)
			) as Observable<IDeleteRequest<number>>;

		this.ws = shared_ws.pipe(
			// Error management!
			tap((val) => {
				console.log('error', val)
				if (isNumber(val)) {
					throw new WebSocketError(<any>val);
				}
			})
		);

		this.updates = this.ws
			.pipe(
				filter(c => isObject(c) && 'version' in c),
				merge(this.conflicts.pipe(
					filter(c => !!c.most_recent),
					map(c => c.most_recent)
				)),
				map((c: IAppuntamento) => {
					console.log('updates', c)

					c.start = moment.utc(c.start);
					if(c.end) {
						c.end = moment.utc(c.end);
						c.allDay = false;
					} else {
						c.allDay = true;
					}
					return c;
				})
			);
	}

	public upsert(appuntamento: IAppuntamento) {
		//console.log('appuntamento', appuntamento)
		this.updater.next(appuntamento);
	}

	public delete(id: number) {
		this.updater.next({
			delete: id
		});
	}

	public delete_group(id: number) {
		this.updater.next({
			delete_group: id
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/model/appuntamenti.ts